import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableMagicLinkStatus = loadable(() => import('./MagicLinkStatus'), {
  fallback: <LoadingScreen />,
});

export default LoadableMagicLinkStatus;
